import script from "./AppDateTime.vue?vue&type=script&setup=true&lang=js"
export * from "./AppDateTime.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__